import { render, staticRenderFns } from "./ServiceQuestionServerTable.vue?vue&type=template&id=565c3c9c"
import script from "./ServiceQuestionServerTable.vue?vue&type=script&lang=js"
export * from "./ServiceQuestionServerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports